import React from 'react';
import { Typography } from '@mui/material';
import { styled } from "@mui/material/styles";

import Button from '@shared-components/atoms/Button';
import { StoreLocalizationProps } from './types';

const StyledContainer = styled("div")(({ theme }) => ({
    display: 'flex',
    flex: 1,
    margin: '0 auto',
    maxWidth: '1152px',
    justifyContent: 'center',
    alignItems: 'end',
    [theme.breakpoints.up("md")]: {
        justifyContent: 'end',
        alignItems: 'start'
    }
}));

const StyledLocalization = styled("div")(({ theme }) => ({
    backgroundColor: "#fff",
    padding: "24px",
    borderRadius: "8px",
    position: 'relative',
    top: '60px',
    width: '95%',
    boxShadow: '0px 3px 8px 0px rgba(0, 0, 0, 0.2995)',
    [theme.breakpoints.up("md")]: {
        marginTop: "50px",
        marginInline: 'initial',
        width: 'auto',
        position: 'static',
        boxShadow: 'none'
    }
}));

const StyledTitle = styled("h1")(({ theme }) => ({
    fontSize: '28px',
    fontFamily: 'PizzaHutFont',
    fontWeight: 'initial',
    marginBlock: "5px 10px",
    [theme.breakpoints.up("md")]: {
        fontSize: "48px",
        marginBlock: "18px 10px"
    }
}));

const StyledMessage = styled(Typography)(({ theme }) => ({
    fontSize: '14px',
    marginBottom: '15px',
    [theme.breakpoints.up("md")]: {
        fontSize: "16px"
    }
}));

const StyledCTAContainer = styled("div")({
    display: 'flex',
    justifyContent: 'center'
});

const StyledCTA = styled(Button)(({ theme }) => ({
    width: '100%',
    height: '40px',
    alignItems: 'center',
    [theme.breakpoints.up("md")]: {
        width: "65%"
    }
}));

export const StoreLocalization = ({title, description, buttonText, handleOpenLocalizationRail}: StoreLocalizationProps) => (
        <StyledContainer>
            <StyledLocalization>
                <StyledTitle component="h1">{title}</StyledTitle>
                <StyledMessage>{description}</StyledMessage>
                <StyledCTAContainer>
                    <StyledCTA onClick={handleOpenLocalizationRail}>{buttonText}</StyledCTA>
                </StyledCTAContainer>
            </StyledLocalization>
        </StyledContainer>
    );

export default StoreLocalization;